/* eslint-disable import/no-default-export */
import React from 'react';
import styled from 'styled-components';

import Avatar from '../shared/Avatar';
import Input from './Input';
import TrelloLogo from './TrelloLogo';

const Container = styled.div`
  * {
    vertical-align: middle;
  }

  ${Avatar}, ${Input} {
    margin-right: 8px;
  }

  ${Input} {
    width: 142px; /* TODO: figure out a better way to do this */
  }
`;

const CardCommentSection = ({ className = '' }) => (
  <Container className={className}>
    <Avatar img="https://api.adorable.io/avatars/40/gerard.png" size={24} />
    <Input />
    <TrelloLogo />
  </Container>
);

export default CardCommentSection;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/CardCommentSection.js